import { render, staticRenderFns } from "./selectCustomer.vue?vue&type=template&id=6bfad0d1"
import script from "./selectCustomer.ts?vue&type=script&lang=js&external"
export * from "./selectCustomer.ts?vue&type=script&lang=js&external"
import style0 from "./selectCustomer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports